import React from "react";
import { NavLink } from "react-router-dom";
import "../../../Components/layout/Layout.css"; // reuse same sidebar CSS
import logo from "../../../assets/images/logo.png"; // same logo

export default function AdminSidebar() {
  return (
    <aside className="ls-sidebar">
      <div className="ls-logo-wrap">
        <div className="ls-logo">
          <img src={logo} alt="Legacy Seventy2 Logo" className="logo-img" />
        </div>
      </div>

      <div className="ls-sections">
        {/* MAIN SECTION */}
        <section className="ls-block">
          <div className="ls-block-title">Main</div>
          <nav className="ls-nav">
            <NavLink
              to="/admin/dashboard"
              className={({ isActive }) => (isActive ? "active" : undefined)}
            >
              <IconDashboard /> <span>Dashboard</span>
            </NavLink>
            <NavLink
              to="/admin/companies"
              className={({ isActive }) => (isActive ? "active" : undefined)}
            >
              <IconBuilding /> <span>Companies</span>
            </NavLink>
            <NavLink
              to="/admin/users"
              className={({ isActive }) => (isActive ? "active" : undefined)}
            >
              <IconUserManage /> <span>User Management</span>
            </NavLink>
            <NavLink
              to="/admin/communities"
              className={({ isActive }) => (isActive ? "active" : undefined)}
            >
              <IconUsers /> <span>Communities</span>
            </NavLink>
            <NavLink
              to="/admin/analytics"
              className={({ isActive }) => (isActive ? "active" : undefined)}
            >
              <IconChart /> <span>Analytics</span>
            </NavLink>
            <NavLink
              to="/admin/learning-library"
              className={({ isActive }) => (isActive ? "active" : undefined)}
            >
              <IconLibrary /> <span>Learning Library</span>
            </NavLink>
          </nav>
        </section>

        {/* OTHER SECTION */}
        <section className="ls-block ls-block-bottom">
          <div className="ls-block-title">Other</div>
          <nav className="ls-nav">
            <NavLink
              to="/admin/settings"
              className={({ isActive }) => (isActive ? "active" : undefined)}
            >
              <IconSettings /> <span>Settings</span>
            </NavLink>
            <NavLink
              to="/admin/help"
              className={({ isActive }) => (isActive ? "active" : undefined)}
            >
              <IconHelp /> <span>Help &amp; Support</span>
            </NavLink>
          </nav>
        </section>
      </div>
    </aside>
  );
}

/* ------------ Inline Icons (same style) ------------ */
const base = {
  width: 18,
  height: 18,
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 1.8,
  strokeLinecap: "round",
  strokeLinejoin: "round",
};

function IconDashboard() {
  return (
    <svg {...base}>
      <rect x="3" y="3" width="7" height="7" rx="2" />
      <rect x="14" y="3" width="7" height="7" rx="2" />
      <rect x="14" y="14" width="7" height="7" rx="2" />
      <rect x="3" y="14" width="7" height="7" rx="2" />
    </svg>
  );
}
function IconBuilding() {
  return (
    <svg {...base}>
      <rect x="3" y="3" width="18" height="18" rx="2" />
      <line x1="9" y1="9" x2="9" y2="9" />
      <line x1="9" y1="13" x2="9" y2="13" />
      <line x1="15" y1="9" x2="15" y2="9" />
      <line x1="15" y1="13" x2="15" y2="13" />
    </svg>
  );
}
function IconUsers() {
  return (
    <svg {...base}>
      <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
      <circle cx="9" cy="7" r="4" />
      <path d="M22 21v-2a4 4 0 0 0-3-3.87" />
      <path d="M16 3.13a4 4 0 0 1 0 7.75" />
    </svg>
  );
}
function IconChart() {
  return (
    <svg {...base}>
      <path d="M3 3v18h18" />
      <rect x="7" y="12" width="3" height="6" />
      <rect x="12" y="9" width="3" height="9" />
      <rect x="17" y="5" width="3" height="13" />
    </svg>
  );
}
function IconSettings() {
  return (
    <svg {...base}>
      <circle cx="12" cy="12" r="3" />
      <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 1 1-2.83 2.83l-.06-.06A1.65 1.65 0 0 0 15 19.4a1.65 1.65 0 0 0-1 .6 1.65 1.65 0 0 1-2 0 1.65 1.65 0 0 0-1-.6 1.65 1.65 0 0 0-1.82.33l-.06.06A2 2 0 1 1 7 5.29l.06.06A1.65 1.65 0 0 0 9 4.6a1.65 1.65 0 0 1 2 0 1.65 1.65 0 0 0 1 .6 1.65 1.65 0 0 0 1.82-.33l.06-.06A2 2 0 1 1 20.71 7l-.06.06A1.65 1.65 0 0 0 19.4 9c.22.29.42.62.6 1a1.65 1.65 0 0 1 0 2c-.18.38-.38.71-.6 1z" />
    </svg>
  );
}
function IconUserManage() {
  return (
    <svg {...base}>
      <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
      <circle cx="9" cy="7" r="4" />
      <polyline points="12 2 15 2 15 5" />
      <path d="M15 2 12 5" />
      <path d="M22 12h-4l-1 3h6" />
      <path d="M17 11v6" />
    </svg>
  );
}
function IconHelp() {
  return (
    <svg {...base}>
      <circle cx="12" cy="12" r="10" />
      <path d="M9.09 9a3 3 0 1 1 5.82 1c0 2-3 2-3 4" />
      <line x1="12" y1="17" x2="12" y2="17" />
    </svg>
  );
}
function IconLibrary() {
  return (
    <svg {...base}>
      <path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20" />
      <path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z" />
      <line x1="8" y1="7" x2="16" y2="7" />
      <line x1="8" y1="11" x2="14" y2="11" />
    </svg>
  );
}
function IconCompetency() {
  return (
    <svg {...base}>
      <path d="M12 2L2 7l10 5 10-5-10-5z" />
      <path d="M2 17l10 5 10-5" />
      <path d="M2 12l10 5 10-5" />
    </svg>
  );
}
